import * as _ from 'lodash';
import {
  CertificateSettingsContext,
  CustomerSettingsContext,
  ECWizardSettingsContext,
  Logging,
  Setting,
  SettingsContext,
} from '../..';

// Update the Settings Object
export const updateSettingsObject = (
  settingsObject: any, // eslint-disable-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  settingsName: 'customers' | 'certificates' | 'ecWizard',
  settings: Setting[],
): SettingsContext => {
  const updatedSettingsObject = _.cloneDeep(settingsObject);

  settings.forEach((setting: Setting) => {
    updatedSettingsObject[settingsName][`${setting.name}${setting.sequenceNumber}`] = setting.activeInd ? setting.value : null;
  });

  if (settingsObject) {
    Logging.Info('Update Settings Object:', updatedSettingsObject);
  } else {
    Logging.Info('Set Settings Object:', updatedSettingsObject);
  }

  return updatedSettingsObject;
};

// Create the Certificate Settings Object
export const createCertificateSettingsObject = (settings: Setting[]): CertificateSettingsContext => {
  const settingsObject: CertificateSettingsContext = {};

  settings.forEach((setting: Setting) => {
    settingsObject[`${setting.name}${setting.sequenceNumber}`] = setting.activeInd ? setting.value : null;
  });

  Logging.Info('Certificate Settings Object:', settingsObject);

  return settingsObject;
};

// Create the Customer Settings Object
export const createCustomerSettingsObject = (settings: Setting[]): CustomerSettingsContext => {
  const settingsObject: CustomerSettingsContext = {};

  settings.forEach((setting: Setting) => {
    settingsObject[`${setting.name}${setting.sequenceNumber}`] = setting.activeInd ? setting.value : null;
  });

  Logging.Info('Customer Settings Object:', settingsObject);

  return settingsObject;
};

// Create the EC Wizard Settings Object
export const createECWizardSettingsObject = (settings: Setting[]): ECWizardSettingsContext => {
  const settingsObject: ECWizardSettingsContext = {};

  settings.forEach((setting: Setting) => {
    settingsObject[`${setting.name}${setting.sequenceNumber}`] = setting.activeInd ? setting.value : null;
  });

  Logging.Info('EC Wizard Settings Object:', settingsObject);

  return settingsObject;
};
